import {
    Thermostat as TemperatureIcon,
    Opacity as HumidityIcon,
    FlashOnOutlined as PowerIcon,
    AirOutlined as PressureIcon,
} from '@mui/icons-material';

export const MEASURE_TYPES = ['TEMP', 'HUMI', 'POWE', 'PRES'];

export const MEASURE_CONFIG = {
    TEMP: {
        id: 'TEMP',
        color: '#ff7300',
        muiColor: 'warning.main',
        lightBg: 'rgba(255, 115, 0, 0.12)',
        unit: '°C',
        translationKey: 'common.temperature',
        axisId: 'tempAxis',
        axisOrientation: 'left',
        decimals: 1,
    },
    HUMI: {
        id: 'HUMI',
        color: '#0088fe',
        muiColor: 'info.main',
        lightBg: 'rgba(0, 136, 254, 0.12)',
        unit: '%',
        translationKey: 'common.humidity',
        axisId: 'humiAxis',
        axisOrientation: 'left',
        decimals: 1,
    },
    POWE: {
        id: 'POWE',
        color: '#10b981',
        muiColor: 'success.main',
        lightBg: 'rgba(16, 185, 129, 0.12)',
        unit: 'kW',
        translationKey: 'common.powerConsumption',
        axisId: 'powerAxis',
        axisOrientation: 'right',
        decimals: 2,
    },
    PRES: {
        id: 'PRES',
        color: '#8b5cf6',
        muiColor: 'secondary.main',
        lightBg: 'rgba(139, 92, 246, 0.12)',
        unit: 'hPa',
        translationKey: 'common.atmosphericPressure',
        axisId: 'presAxis',
        axisOrientation: 'right',
        decimals: 1,
    },
};

export const getMeasureIcon = (type, sx = { fontSize: 30 }) => {
    const config = MEASURE_CONFIG[type];
    if (!config) return null;

    const iconProps = { sx: { ...sx, color: config.muiColor } };

    switch (type) {
        case 'TEMP':
            return <TemperatureIcon {...iconProps} />;
        case 'HUMI':
            return <HumidityIcon {...iconProps} />;
        case 'POWE':
            return <PowerIcon {...iconProps} />;
        case 'PRES':
            return <PressureIcon {...iconProps} />;
        default:
            return null;
        }
};

export const getMeasureUnit = (type) => {
    return MEASURE_CONFIG[type]?.unit || '';
};

export const getMeasureLabel = (type, t) => {
    const key = MEASURE_CONFIG[type]?.translationKey;
    return (key && t) ? t(key) : type;
};

export const getMeasureColor = (type) => {
    return MEASURE_CONFIG[type]?.color || '#000000';
};

export const getMeasureColors = () => {
    return Object.fromEntries(
        Object.entries(MEASURE_CONFIG).map(([key, config]) => [key, config.color])
    );
};

export const getMeasureUnits = () => {
    return Object.fromEntries(
        Object.entries(MEASURE_CONFIG).map(([key, config]) => [key, config.unit])
    );
};

export const getMeasureLabels = (t) => {
    return Object.fromEntries(
        Object.entries(MEASURE_CONFIG).map(([key, config]) => [key, t ? t(config.translationKey) : key])
    );
};

/**
 * Format a measure value with appropriate decimals and unit
 */
export const formatMeasureValue = (type, value) => {
    if (value === null || value === undefined || isNaN(value)) {
        return '—';
    }
    const num = parseFloat(value);
    const decimals = MEASURE_CONFIG[type]?.decimals ?? 2;
    return `${num.toFixed(decimals)} ${getMeasureUnit(type)}`;
};
